import React from 'react';
import './Error404.css';

import { Button, PageTitle } from '../../../components';



const Error404 = () => { 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Error 404'} page={'Error 404'} />

<section className="error-404">
    <div className="box-container">
        <div className="content">
            <h2>404</h2>
            <h5><span>Sorry!</span> Page Not Found</h5>
            <p>The page you're looking for might have been removed, renamed, or doesn't exist. Please check the URL or return to our homepage to browse our collection of HTML and React templates.</p>
            <Button link={'/'} title={'Back to Homepage'} />
        </div>
    </div>
</section>
    </> 
  );
}

export default Error404;